import { render } from "./BulkRemoval.vue?vue&type=template&id=5bf434ab&scoped=true"
import script from "./BulkRemoval.vue?vue&type=script&lang=js"
export * from "./BulkRemoval.vue?vue&type=script&lang=js"

import "./BulkRemoval.vue?vue&type=style&index=0&id=5bf434ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf434ab"]])

export default __exports__